import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import DynamicTitle from "./DynamicTitle";

function CrisisPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <DynamicTitle>Crisis</DynamicTitle>
      <Header />

      <main className="flex-grow max-w-4xl mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4 text-secondary">
          You Are Important and Deserve Support
        </h1>
        <div className="distress-copy mb-6">
          <div className="bg-surfaceTint border-l-4 border-secondary p-4 mb-6 rounded">
            <p className="text-text mb-3">
              <strong>You are cared for. You are loved. You are important.</strong>
            </p>
            <p className="text-textSecondary mb-3">
              We want you to have the best possible support during this difficult time. 
              While our sessions can be helpful for many people, you deserve to work with 
              a caring professional who can interact with you personally and provide 
              the individualized support you need right now.
            </p>
            <p className="text-textSecondary">
              This isn't about you being "too much" for us - it's about us wanting 
              what's truly best for you. You deserve human connection and professional 
              care during challenging moments.
            </p>
          </div>

          <p className="mb-4 text-textSecondary">
            Please reach out to your therapist or mental health provider. If you don't 
            have one, the crisis support resources below can connect you with caring 
            professionals who are trained to help.
          </p>

          <h2 className="text-xl font-semibold mt-4 text-text">
            United States Suicide and Crisis Help
          </h2>
          <p>
            <strong>Emergency:</strong> 911
          </p>
          <p>
            <strong>Suicide & Crisis Lifeline:</strong> Call or text 988
          </p>
          <p>
            <strong>National Domestic Violence Hotline:</strong> 1-800-799-7233
          </p>
          <p>
            <strong>Crisis Text Line:</strong> Text "DESERVE" to 741-741
          </p>
          <p>
            <strong>Lifeline Crisis Chat (Online live messaging):</strong>
            <a
              href="https://988lifeline.org/chat/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:no-underline focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
            >
              {" "}
              988lifeline.org/chat
            </a>
          </p>
          <p>
            <strong>Self-Harm Hotline:</strong> 1-800-DONT CUT (1-800-366-8288)
          </p>
          <p>
            <strong>Essential local and community services:</strong> 211,
            <a
              href="https://www.211.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:no-underline focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
            >
              {" "}
              www.211.org
            </a>
          </p>
          <p>
            <strong>Planned Parenthood Hotline:</strong> 1-800-230-PLAN (7526)
          </p>
          <p>
            <strong>American Association of Poison Control Centers:</strong>{" "}
            1-800-222-1222
          </p>
          <p>
            <strong>
              National Council on Alcoholism & Drug Dependency Hope Line:
            </strong>{" "}
            1-800-622-2255
          </p>
          <p>
            <strong>National Crisis Line - Anorexia and Bulimia:</strong>{" "}
            1-800-233-4357
          </p>
          <p>
            <strong>LGBT Hotline:</strong> 1-888-843-4564
          </p>
          <p>
            <strong>TREVOR Crisis Hotline:</strong> 1-866-488-7386
          </p>
          <p>
            <strong>AIDS Crisis Line:</strong> 1-800-221-7044
          </p>
          <p>
            <strong>Veterans Crisis Line:</strong>
            <a
              href="https://www.veteranscrisisline.net"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:no-underline focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
            >
              {" "}
              www.veteranscrisisline.net
            </a>
          </p>
          <p>
            <strong>TransLifeline:</strong>
            <a
              href="https://www.translifeline.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:no-underline focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
            >
              {" "}
              www.translifeline.org
            </a>{" "}
            - 877-565-8860
          </p>

          <h2 className="text-xl font-semibold mt-6 text-text">International Support</h2>
          <p>
            If you're not in the United States, try one of the numbers listed
            here:
            <a
              href="https://en.wikipedia.org/wiki/List_of_suicide_crisis_lines"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:no-underline focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
            >
              {" "}
              Wikipedia
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default CrisisPage;
